export default __webpack_public_path__ + "static/uday-0bd99467393b5bc69efbb99e34f1d2b0.png";